import { render, staticRenderFns } from "./veStuFileShow.vue?vue&type=template&id=84caca68&scoped=true"
import script from "./veStuFileShow.vue?vue&type=script&lang=js"
export * from "./veStuFileShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84caca68",
  null
  
)

export default component.exports